module.exports = __webpack_public_path__ + "img/lemon.a325ffa2.svg";